export const defaultApiConfig = {
  products: '/cars',
  filters: '/filters/cars',
};
